import { render, staticRenderFns } from "./ListArmazem.vue?vue&type=template&id=2b38a213"
import script from "./ListArmazem.vue?vue&type=script&lang=js"
export * from "./ListArmazem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports